import { render, staticRenderFns } from "./Registers.vue?vue&type=template&id=2030a8bc&lang=pug&"
import script from "./Registers.vue?vue&type=script&lang=ts&"
export * from "./Registers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports